import { render } from "./statistics-page.vue?vue&type=template&id=5cf80406&ts=true"
import script from "./statistics-page.ts?vue&type=script&lang=ts"
export * from "./statistics-page.ts?vue&type=script&lang=ts"

import "./statistics-page.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__